// extracted by mini-css-extract-plugin
export default {"ResponsiveIframe":"BelenderIframe_ResponsiveIframe__j99m2"};